"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var braft_utils_1 = require("braft-utils");
var react_1 = __importDefault(require("react"));
var ControlBarButton_1 = __importDefault(require("./ControlBarButton"));
var transifex_1 = require("../../../transifex");
var alignmetsData = {
    left: {
        icon: react_1.default.createElement(icons_1.AlignLeftOutlined, null),
        tooltip: transifex_1.TX_LEFT_ALIGN,
    },
    center: {
        icon: react_1.default.createElement(icons_1.AlignCenterOutlined, null),
        tooltip: transifex_1.TX_CENTER_ALIGN,
    },
    right: {
        icon: react_1.default.createElement(icons_1.AlignRightOutlined, null),
        tooltip: transifex_1.TX_RIGHT_ALIGN,
    },
};
var Alignment = function (_a) {
    var editorState = _a.editorState, onAlign = _a.onAlign;
    var currentAlignment = braft_utils_1.ContentUtils.getSelectionBlockData(editorState, "textAlign");
    return (react_1.default.createElement(antd_1.Row, { gutter: 8 }, Object.keys(alignmetsData).map(function (alignment) {
        var alignmentData = alignmetsData[alignment];
        return (react_1.default.createElement(antd_1.Col, null,
            react_1.default.createElement(ControlBarButton_1.default, { tooltip: alignmentData.tooltip, active: currentAlignment === alignment, onClick: function () { return onAlign(alignment); }, icon: alignmentData.icon })));
    })));
};
exports.default = Alignment;
